module.exports = __webpack_public_path__ + "static/assets/73657c50cc3cd5b45ad44a11fff232ac.svg";